import { observer } from 'mobx-react';
import * as React from 'react';
import { WrappedField } from '../../../core/forms';

interface DefaultTextInputProps {
    field: WrappedField<string>;
    label: string;
    required?: boolean;
    type?: string;
    className?: string;
    'data-role'?: string;
    disabled?: boolean;
}

export const DefaultTextInput = observer(function DefaultTextInput(
    props: DefaultTextInputProps
) {
    const { className, field, label, type, required } = props;

    const onChange = (
        event: React.SyntheticEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        const { value } = event.currentTarget;
        field.fromInput = value;
    };

    return (
        <dd className={classnames(className, 'field-group__member')}>
            <input
                alt={label}
                placeholder={label}
                required={required}
                value={field.value}
                type={type}
                onChange={onChange}
                data-role={props['data-role']}
                disabled={props.disabled}
            />
        </dd>
    );
});
